import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { formatNumber } from 'libphonenumber-js';
import { PrintService } from '../../../../services/print.service';
import { CountriesService } from '../../../../services/countries.service';

@Component({
  selector: 'select-shipping-address',
  styleUrls: [
    '../../../wizard/wizard.component.scss',
    '../step2.component.scss',
    './selectAddress.component.scss',
  ],
  templateUrl: './selectAddress.component.html',
})
export class SelectShippingAddressComponent {
  @Input() addresses;
  @Input() step;
  @Input() totalSteps;
  @Input() edit;
  @Input() remove;
  @Input() prev;
  @Input() next;

  constructor(
    private translate: TranslateService,
    private printService: PrintService,
    private countriesService: CountriesService
  ) {}

  confirmRemove(address) {
    let message;
    this.translate.get('confirm_delete_address').subscribe((res: string) => {
      message = res;
    });

    if (window.confirm(message)) {
      this.remove(address);
    }
  }

  selectAddress(address) {
    this.printService.shippingAddress = address;
    this.printService.specs.shipping_address_id = address.uuid;
  }

  isAddressSelected(uuid) {
    return this.printService.specs.shipping_address_id === uuid;
  }

  isNextStepReady() {
    return this.printService.specs.shipping_address_id;
  }

  displayZipAndCity(address) {
    if (address.country_code === 'US') {
      return `${address.city}, ${address.state} ${address.zip_code}`;
    } else {
      return `${address.zip_code} ${address.city}`;
    }
  }

  displayCountry(code) {
    return this.countriesService.get(code).name;
  }

  formatNumber(number) {
    return formatNumber(number, 'International');
  }
}
